export const OpenLockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24">
		<path
			fill="currentColor"
			d="M6.5455 9.8182V6.5455c-.0011-1.1673.4516-2.2582 1.2741-3.0873.8237-.8291 1.92-1.2764 3.0851-1.2764h.0044c2.0673 0 3.865 1.4618 4.2764 3.491.121.589.6927.9817 1.2872.8508.5902-.12.971-.6981.851-1.2872C16.7061 2.2036 14.0094 0 10.909 0h-.0066C9.155 0 7.511.6764 6.276 1.92 5.041 3.1527 4.3625 4.8 4.3636 6.5455v3.2727H3.2727C1.4684 9.8182 0 11.2909 0 13.0909v7.6364C0 22.5273 1.4684 24 3.2727 24h15.2728c1.8043 0 3.2727-1.4727 3.2727-3.2727v-7.6364c0-1.8-1.4684-3.2727-3.2727-3.2727h-12ZM5.4382 12h13.1073c.6021 0 1.0909.491 1.0909 1.091v7.6363c0 .6-.4888 1.0909-1.091 1.0909H3.2728c-.601 0-1.0909-.491-1.0909-1.091V13.091c0-.6.4898-1.0909 1.091-1.0909h2.1654Z"
			fillRule="evenodd"
		/>
	</svg>
);
